import React from "react";

import { isFeatureEnabled } from "@editor/infra/featureFlags";
import { selectProjectId } from "@editor/reducers/core-reducer";
import { useEditorSelector } from "@editor/store";

import { GenerateTemplatesForm } from "@/components/GenerateTemplatesForm";

import { DeployButton } from "../next-gen/components/DeployButton";
import EditorChat from "./components/EditorChat";
import ManageChats from "./components/ManageChats";
import ReactInlineEditor from "./components/ReactInlineEditor";
import { useIframeMessaging } from "./useIframeMessaging";

function ReactEditor() {
  const isReactEditorEnabled = isFeatureEnabled("reaplo");
  const projectId = useEditorSelector(selectProjectId);
  useIframeMessaging();

  if (!isReactEditorEnabled) {
    window.location.href = `/projects/${projectId}`;
    return null;
  }
  return (
    <div className="flex h-screen gap-3 p-3">
      <div className="flex h-full flex-col gap-5">
        <GenerateTemplatesForm />

        <div className="flex h-full min-h-0 max-w-md flex-col gap-4 rounded-md border p-4">
          <h1 className="text-2xl font-bold">Chat For Editing</h1>
          <ManageChats />
          <EditorChat />
        </div>
      </div>

      <ReactInlineEditor />
      <DeployButton />
    </div>
  );
}

export default ReactEditor;
